import React from "react";

// router link
import { useNavigate } from "react-router-dom";

type IButtonLink = {
  link: string;
  className?: string;
  children?: React.ReactNode;
  asChild?: boolean;
};

const ButtonLink: React.FC<IButtonLink> = ({ children, link, className }) => {
  const navigate = useNavigate();
  return (
    <button
      type="button"
      onClick={() => navigate(link)}
      className={`inline-flex items-center gap-3 py-3 font-medium rounded-full text-md px-9 text-center overflow-hidden ${className}`}
    >
      {children}
    </button>
  );
};

export default ButtonLink;
